module.exports = __webpack_public_path__ + "img/icon-treasure-shadow.2a99dfb1.png";